module.exports = __webpack_public_path__ + "img/numSix.0f64cb2b.png";